import React from 'react';
import styled from 'styled-components';
import { IndicatorSectionKey } from '../ImpactIndicator/utils';
import CapacityDevelopmentIcon from 'shared/statics/svg/icon_stage_capacity-development.svg?react';
import ReachIcon from 'shared/statics/svg/icon_stage_reach.svg?react';
import LearnIcon from 'shared/statics/svg/icon_stage_learn.svg?react';
import ActIcon from 'shared/statics/svg/icon_stage_act.svg?react';
import SucceedIcon from 'shared/statics/svg/icon_stage_succeed.svg?react';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

export const IndicatorSectionIcon: React.FC<{
  sectionKey: IndicatorSectionKey;
  className?: string;
}> = ({ sectionKey, className }) => {
  switch (sectionKey) {
    case 'reach':
      return <ReachIcon className={className} />;
    case 'learn':
      return <LearnIcon className={className} />;
    case 'act':
      return <ActIcon className={className} />;
    case 'succeed':
      return <SucceedIcon className={className} />;
    default:
    case 'capacityDevelopment':
      return <CapacityDevelopmentIcon className={className} />;
  }
};

interface SummaryIconProps {
  size?: number;
  maxWidth?: number;
  sectionKey: IndicatorSectionKey;
  text: string;
  className?: string;
}

interface StyleProps {
  size: number;
  maxWidth: number;
}

const StyledDiv = styled.div<StyleProps>`
  width: ${({ maxWidth }) => `${maxWidth}px`};
  margin-left: auto;
  margin-right: auto;
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    background-color: ${COLORS.ctaBrandBackground};
    border-radius: 50px;
    svg {
      width: ${({ size }) => `${size / 2}px`};
      height: ${({ size }) => `${size / 2}px`};
      path {
        stroke: ${COLORS.ctaBrand};
      }
    }
  }
  .bold {
    margin-top: ${SPACERS.tiny};
    font-weight: bold;
    text-align: center;
  }
`;

const SummaryIcon: React.FC<SummaryIconProps> = ({
  size = 64,
  maxWidth = 111,
  sectionKey,
  text,
  className,
}) => (
  <StyledDiv size={size} maxWidth={maxWidth} className={className}>
    <div className="icon">
      <IndicatorSectionIcon sectionKey={sectionKey} />
    </div>
    <TrueImpactText variant="body-small" className="bold">
      {text}
    </TrueImpactText>
  </StyledDiv>
);

export default SummaryIcon;
